"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = exports.liveDonorScreeningInProgressMessages = exports.LiveDonorScreeningInProgress = void 0;
const schema_1 = require("../../../schema");
var LiveDonorScreeningInProgress;
(function (LiveDonorScreeningInProgress) {
    LiveDonorScreeningInProgress["YES"] = "YES";
    LiveDonorScreeningInProgress["NO"] = "NO";
    LiveDonorScreeningInProgress["UNKNOWN"] = "UNKNOWN";
})(LiveDonorScreeningInProgress || (exports.LiveDonorScreeningInProgress = LiveDonorScreeningInProgress = {}));
exports.liveDonorScreeningInProgressMessages = {
    [LiveDonorScreeningInProgress.YES]: {
        id: "ktx.basicRegistrationData.liveDonorScreening.liveDonorScreeningInProgress.YES",
        defaultMessage: "Igen"
    },
    [LiveDonorScreeningInProgress.NO]: {
        id: "ktx.basicRegistrationData.liveDonorScreening.liveDonorScreeningInProgress.NO",
        defaultMessage: "Nem"
    },
    [LiveDonorScreeningInProgress.UNKNOWN]: {
        id: "ktx.basicRegistrationData.liveDonorScreening.liveDonorScreeningInProgress.UNKNOWN",
        defaultMessage: "Nem ismert"
    }
};
const liveDonorScreeningInProgress = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(LiveDonorScreeningInProgress.YES),
    schema_1.Schema.singleChoiceItem(LiveDonorScreeningInProgress.NO),
    schema_1.Schema.singleChoiceItem(LiveDonorScreeningInProgress.UNKNOWN)
]);
exports.validator = schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({ liveDonorScreeningInProgress })
    .interpretation({ vocab: "ktx", code: "live_donor_screening" });
